import { defineComponent as _defineComponent } from 'vue'

import {useRouter} from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemAd',
  props: {
    data: {
        type: Object,
        default: () => ({}),
    },
    index: {
        type: Number,
        default: -1,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props


const router = useRouter();
const toSellerShop = () => {
    router.push({name: 'SellerShop', query: {id: props.data.appUrl.id}});
};

const __returned__ = { props, router, toSellerShop, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})